'use strict';

var _ = require('lodash');
var DemandPostingPanelController = function DemandPostingPanelController($rootScope, $scope, $filter, demandPostingService, applyOperationService, featureToggleService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var originDestination = $scope.contextData.market.split('-');
  $scope.showDemandPostingDropDowns = false;
  function getDateRangeLabel(ranges) {
    if (ranges.length > 1) {
      return 'Multiple';
    } else {
      var range = ranges[0] || {};
      return rmMomentFormat(range.from, 'DATE_USER_SETTINGS') + ' - ' + rmMomentFormat(range.to, 'DATE_USER_SETTINGS');
    }
  }
  function buildCriteriaLabels(context) {
    var labels = [{
      label: 'Departure dates',
      css: 'dates',
      value: getDateRangeLabel(context.dateRanges) || ''
    }, {
      label: 'Seasons',
      css: 'seasons',
      value: context.seasons ? context.seasons.join(', ') : ''
    }];
    if (featureToggleService.isEnabled('SPOS') && context.poses) {
      labels.push({
        label: 'POS',
        css: 'pos',
        value: context.poses ? context.poses.join(', ') : ''
      });
    }
    return labels;
  }
  function getOldValues(selectedPG) {
    if (!selectedPG) {
      return {};
    }
    return {
      oldValue: $scope.pgOldData[selectedPG.id],
      newValue: $scope.pgOldData[selectedPG.id],
      maxValue: $scope.pgOldData[selectedPG.id]
    };
  }
  function setOldValues(operation) {
    operation.sourceDemand = getOldValues(operation.sourceProductGroup.selectedItem);
    operation.targetDemand = getOldValues(operation.targetProductGroup.selectedItem);
  }
  function setMaxValues(operation) {
    var isSwap = operation.shiftSwap.selectedItem.id === 'SWAP';
    var sumValue = operation.sourceDemand.oldValue + operation.targetDemand.oldValue;
    var maxDemandValue = _.max([operation.sourceDemand.oldValue, operation.targetDemand.oldValue]);
    if (sumValue) {
      operation.sourceDemand.maxValue = isSwap ? maxDemandValue : sumValue;
      operation.targetDemand.maxValue = isSwap ? maxDemandValue : sumValue;
    }
  }
  function setNewValues(operation) {
    var amountToChange;
    if (operation.shiftSwap.selectedItem.id === 'SWAP') {
      operation.sourceDemand.newValue = operation.targetDemand.oldValue;
      operation.targetDemand.newValue = operation.sourceDemand.oldValue;
    } else {
      amountToChange = operation.sourceDemand.oldValue * operation.adjAmount.percentageValue;
      if (_.isFinite(amountToChange)) {
        operation.sourceDemand.newValue = operation.sourceDemand.oldValue - amountToChange;
        operation.targetDemand.newValue = operation.targetDemand.oldValue + amountToChange;
      }
    }
  }
  function getAlreadyTakenIds() {
    var alreadyTakenIds = [];
    _.forEach($scope.operations, function (operation) {
      if (operation.sourceProductGroup.selectedItem) {
        alreadyTakenIds.push(operation.sourceProductGroup.selectedItem.id);
      }
      if (operation.targetProductGroup.selectedItem) {
        alreadyTakenIds.push(operation.targetProductGroup.selectedItem.id);
      }
    });
    return alreadyTakenIds;
  }
  $scope.initOperations = function () {
    demandPostingService.loadRealDemandData($scope.contextData, $scope.dimension).then(function (pgOldData) {
      $scope.pgOldData = pgOldData;
      $scope.operations = [demandPostingService.createOperation($scope.contextData)];
    });
  };
  $scope.tooltipContent = buildCriteriaLabels($scope.contextData);
  $scope.type = demandPostingService.getDemandPostingType($scope.contextData);
  $scope.productGroupItems = demandPostingService.getProductGroupItems($scope.contextData);
  $scope.origin = originDestination[0];
  $scope.destination = originDestination[1];
  $scope.nextBtnEnabled = false;
  $scope.onCancelButtonClick = function () {
    $rootScope.$broadcast('demand-posting:swap', false);
  };
  $scope.enableNextBtn = function () {
    $scope.nextBtnEnabled = _.every($scope.operations, function (operation) {
      var source = operation.sourceDemand;
      var target = operation.targetDemand;
      var sourceSelected = operation.sourceProductGroup.selectedItem;
      var targetSelected = operation.targetProductGroup.selectedItem;
      return source && target && sourceSelected && targetSelected && sourceSelected.id !== '' && targetSelected.id !== '' && source.oldValue !== source.newValue && target.oldValue !== target.newValue && operation.targetProductGroup.selectedItem;
    });
  };
  $scope.onSubmit = function () {
    return false;
  };
  $scope.enableAddNewRowBtn = function () {
    var enabled = $scope.productGroupItems;
    enabled = enabled && $scope.operations;
    enabled = enabled && $scope.productGroupItems.length - 2 * $scope.operations.length >= 2;
    $scope.addNewRowBtnEnabled = enabled;
  };
  $scope.onProductGroupChange = function () {
    var alreadyTakenIds = getAlreadyTakenIds();
    var productGroupsForTaken = _.filter($scope.productGroupItems, function (item) {
      return !_.includes(alreadyTakenIds, item.id);
    });
    productGroupsForTaken.unshift({
      id: '',
      label: 'Select...'
    });
    _.forEach($scope.operations, function (operation) {
      operation.sourceProductGroup.possibleItems = productGroupsForTaken;
      operation.targetProductGroup.possibleItems = productGroupsForTaken;
    });
    $scope.enableNextBtn();
    $scope.enableAddNewRowBtn();
  };
  $scope.onAdjAmountChange = function (operationIdx) {
    var operation = $scope.operations[operationIdx];
    setOldValues(operation);
    setMaxValues(operation);
    setNewValues(operation);
    $scope.enableNextBtn();
    $scope.enableAddNewRowBtn();
  };
  $scope.onDeleteOperation = function (operationIdx) {
    $scope.operations.splice(operationIdx, 1);
  };
  $scope.openConfirmationModal = function () {
    $rootScope.$broadcast('demand-posting:open-confirmation-modal', $scope.contextData.market);
  };
  $scope.onModalConfirmation = function () {
    var gridParams = $scope.contextData.gridParams;
    demandPostingService.loadGridData(gridParams).then(function (gridData) {
      gridData = _.filter(gridData, function (o) {
        return $scope.contextData.market === o.market;
      });
      var overrideData = applyOperationService.getGridOverrides(gridData, gridParams, $scope.operations, $scope.dimension);
      $rootScope.$broadcast('demand-posting:swap', false);
      setTimeout(function () {
        $rootScope.$broadcast('grid:fillBulkOverrides', gridParams.gridId, overrideData);
      }, 0);
    });
  };
  $scope.onAddOperation = function () {
    $scope.operations.push(demandPostingService.createOperation($scope.contextData));
  };
  $scope.$watchGroup(['contextData', 'dimension'], function () {
    $scope.initOperations();
  });
  $scope.$watch('operations.length', function () {
    $scope.onProductGroupChange();
  });
};
DemandPostingPanelController.$inject = ['$rootScope', '$scope', '$filter', 'DemandPostingService', 'DemandPostingApplyOperationService', 'FeatureToggleService'];
module.exports = DemandPostingPanelController;